import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "./api";
import { useAuth } from "./AuthContext";

const NotifCtx = createContext(null);

export function NotificationProvider({ children }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const refresh = useCallback(async () => {
    if (!user) { setItems([]); setUnread(0); return; }
    try {
      const { data } = await api.get("/notifications");
      setItems(data.items || []);
      setUnread(data.unread_count || 0);
    } catch { setItems([]); setUnread(0); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  // Poll for new notifications every 30s
  useEffect(() => {
    if (!user) return;
    const t = setInterval(refresh, 30000);
    return () => clearInterval(t);
  }, [user, refresh]);

  const markRead = useCallback(async (notif_id) => {
    await api.post(`/notifications/${notif_id}/read`);
    setItems(prev => prev.map(i => i.notif_id === notif_id ? { ...i, read: true } : i));
    setUnread(prev => Math.max(0, prev - 1));
  }, []);

  const markAllRead = useCallback(async () => {
    await api.post("/notifications/read_all");
    setItems(prev => prev.map(i => ({ ...i, read: true })));
    setUnread(0);
  }, []);

  const value = useMemo(
    () => ({ items, unread, refresh, markRead, markAllRead }),
    [items, unread, refresh, markRead, markAllRead],
  );

  return (
    <NotifCtx.Provider value={value}>
      {children}
    </NotifCtx.Provider>
  );
}

export const useNotifications = () => useContext(NotifCtx);
